<div class="transcript-panel" [innerHTML]="transcript"></div>
